import React, { useEffect, useRef, useState } from 'react';
import classes from './AlgoliaSearch.module.scss';
import searchIcon from "../../../assets/icons/search.png";
import algoliaLogo from "../../../assets/icons/algolia-logo.svg";
import { trucksIndex, vendorsIndex, paymentsIndex, campaignsIndex } from '../../../services/algolia';
import { Link } from 'react-router-dom';
import Paginator from './Paginator';
import { Modal, ModalBody } from "reactstrap";
import _ from 'lodash'
import moment from "moment";

const AlgoliaSearch = ({ togglePopup, instantSearchOpen }) => {
  const inputRef = useRef(null);

  const [searchQuery, setSearchQuery] = useState('');
  const [hitsPerPage, setHitsPerPage] = useState(10);

  const [vendorCurrentPage, setVendorCurrentPage] = useState(0);
  const [totalVendorPages, setTotalVendorPages] = useState(0);
  const [vendors, setVendors] = useState([]);

  const [truckCurrentPage, setTruckCurrentPage] = useState(0);
  const [trucks, setTrucks] = useState([]);
  const [totalTruckPages, setTotalTruckPages] = useState(0);

  const [paymentCurrentPage, setPaymentCurrentPage] = useState(0);
  const [payments, setPayments] = useState([]);
  const [totalPaymentPages, setTotalPaymentPages] = useState(0);

  const [campaignCurrentPage, setCampaignCurrentPage] = useState(0);
  const [campaigns, setCampaigns] = useState([]);
  const [totalCampaignPages, setTotalCampaignPages] = useState(0);

  const [dataFetched, setDataFetched] = useState(false);


  useEffect(() => {
    const debouncedHandler = _.debounce(value => {
      if (searchQuery.length > 0) {
        handleSearch();
      } else setDataFetched(false);
    }, 1000);

    debouncedHandler(searchQuery);

    return () => {
      debouncedHandler.cancel();
    };
  }, [searchQuery]);

  useEffect(() => {
    if (instantSearchOpen) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 100);
    }
  }, [instantSearchOpen])

  useEffect(() => {
    if (searchQuery.length > 0) searchVendors();
  }, [vendorCurrentPage])

  useEffect(() => {
    if (searchQuery.length > 0) searchTrucks();
  }, [truckCurrentPage])

  useEffect(() => {
    if (searchQuery.length > 0) searchPayments();
  }, [paymentCurrentPage])

  useEffect(() => {
    if (searchQuery.length > 0) searchCampaigns();
  }, [campaignCurrentPage])

  const handleSearch = () => {
    setVendorCurrentPage(0);    
    setTruckCurrentPage(0);
    setPaymentCurrentPage(0);
    searchVendors();
    searchTrucks();
    searchPayments();
    searchCampaigns();
  }

  const searchVendors = async () => {
    try {
      const _vendors = await vendorsIndex.search(searchQuery, {
        page: vendorCurrentPage,
        hitsPerPage: hitsPerPage
      });
      setVendors(_vendors.hits);
      setTotalVendorPages(_vendors.nbPages);
      setDataFetched(true);
    } catch (error) {
      console.log(error);
    }
  }

  const searchTrucks = async () => {
    try {
      const _trucks = await trucksIndex.search(searchQuery, {
        page: truckCurrentPage,
        hitsPerPage: hitsPerPage
      });
      setTrucks(_trucks.hits)
      setTotalTruckPages(_trucks.nbPages);
      setDataFetched(true);
    } catch (error) {
      console.log(error);
    }
  }

  const searchPayments = async () => {
    try {
      const _payments = await paymentsIndex.search(searchQuery, {
        page: paymentCurrentPage,
        hitsPerPage: hitsPerPage
      });
      setPayments(_payments.hits)
      setTotalPaymentPages(_payments.nbPages);
      setDataFetched(true);
    } catch (error) {
      console.log(error);
    }
  }

  const searchCampaigns = async () => {
    try {
      const _campaigns = await campaignsIndex.search(searchQuery, {
        page: campaignCurrentPage,
        hitsPerPage: hitsPerPage
      });
      setCampaigns(_campaigns.hits)
      setTotalCampaignPages(_campaigns.nbPages);
      setDataFetched(true);
    } catch (error) {
      console.log(error);
    }
  }

  const isValidJSON = (jsonString) => {
    try {
      JSON.parse(jsonString);
      return true;
    } catch (error) {
      return false;
    }
  }

  const ParsePaymentDates = ({ payment }) => {
    let _payments;
    if (isValidJSON(payment)) _payments = JSON.parse(payment).map(p => p.start_date_to_end_date);
    else _payments = payment.map(p => p.start_date_to_end_date);

    return (
      <div className={classes.chipsContainer}>
        {_payments.map((payment, index) => {
          if (payment === ' to ') {
            return (<div>-</div>)
          } else return (
            <div className={classes.chip} key={'_p_' + index}>{payment}</div>
          )
        })}
      </div>
    )
  }

  const fetchNextVendorsRecords = (event, page) => {
    if (page - 1 !== vendorCurrentPage) {
      setVendorCurrentPage(page - 1);
    }
  }

  const fetchNextTrucksRecords = (event, page) => {
    if (page - 1 !== truckCurrentPage) {
      setTruckCurrentPage(page - 1);
    }
  }

  const fetchNextPaymentsRecords = (event, page) => {
    if (page - 1 !== paymentCurrentPage) {
      setPaymentCurrentPage(page - 1);
    }
  }

  const fetchNextCampaignsRecords = (event, page) => {
    if (page - 1 !== campaignCurrentPage) {
      setCampaignCurrentPage(page - 1);
    }
  }

  const checkForEmptyValues = (value) => {
    // debugger;
    return value?.length === 0 ? '-' : value
  }

  return (
    <Modal className="search-modal" isOpen={instantSearchOpen} toggle={togglePopup}>
      <ModalBody style={{ background: '#eaeaea' }}>
        <>
          <div className={classes.algoliaWrapper}>
            <div className={classes.searchBarWrapper}>
              <div className={classes.searchBar}>
                <img className={classes.searchIcon} src={searchIcon} alt-text="Search Icon" alt="Search Icon" />
                <input ref={inputRef} type="text" placeholder="Search..." onChange={(e) => setSearchQuery(e.target.value)} value={searchQuery} />
              </div>
            </div>
            <hr className={!dataFetched ? classes.dividerWithMargin : classes.divider} />

            {/* Vendors */}
            {dataFetched &&
              <div className={classes.dataWrapper}>
                {vendors && vendors.length > 0 && 
                  <>
                    <div className={classes.dataTitle}>Vendors</div>
                    <div className={classes.dataList}>
                      {vendors.map((vendor, index) => {
                        return (
                          <Link to={`/dashboard/admin/drive/vendor/edit/${vendor.vendor_id}`} onClick={() => togglePopup()} key={'vendor_' + index} className={classes.dataCard}>
                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>Vendor Name</div>
                              <div dangerouslySetInnerHTML={{ __html: checkForEmptyValues(vendor?._highlightResult?.name?.value) }}></div>
                            </div>

                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>Nickname</div>
                              <div dangerouslySetInnerHTML={{ __html: checkForEmptyValues(vendor?._highlightResult?.nickname?.value) }}></div>
                            </div>

                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>City</div>
                              <div dangerouslySetInnerHTML={{ __html: checkForEmptyValues(vendor?._highlightResult?.city?.value) }}></div>
                            </div>

                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>Email</div>
                              <div dangerouslySetInnerHTML={{ __html: checkForEmptyValues(vendor?._highlightResult?.email?.value) }}></div>
                            </div>

                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>Phone No</div>
                              <div dangerouslySetInnerHTML={{ __html: checkForEmptyValues(vendor?._highlightResult?.phone_num?.value) }}></div>
                            </div>
                          </Link>
                        )
                      })}
                    </div>
                    <Paginator fetchRecords={fetchNextVendorsRecords} currentPage={vendorCurrentPage} pages={totalVendorPages}/>
                    <hr style={{margin: "30px auto"}} />
                  </>
                }

                {/* Trucks */}
                {trucks && trucks.length > 0 && 
                  <>
                    <div className={classes.dataTitle}>Trucks</div>
                    <div className={classes.dataList}>
                      {trucks.map((truck, index) => {
                        return (
                          <Link to={`/dashboard/admin/drive/vendor/truck/edit/${truck.truck_id}`} onClick={() => togglePopup()} key={'truck_' + index} className={classes.dataCard}>
                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>Truck Name</div>
                              <div dangerouslySetInnerHTML={{ __html: checkForEmptyValues(truck?._highlightResult?.truck_name?.value) }}></div>
                            </div>

                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>Vendor Name</div>
                              <div dangerouslySetInnerHTML={{ __html: checkForEmptyValues(truck?._highlightResult?.vendor_name?.value) }}></div>
                            </div>

                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>License Plate</div>
                              <div dangerouslySetInnerHTML={{ __html: checkForEmptyValues(truck?._highlightResult?.license_plate?.value?.slice(1, -1)) }}></div>
                            </div>

                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>Active Campaign</div>
                              <div dangerouslySetInnerHTML={{ __html: checkForEmptyValues(truck?._highlightResult?.campaign_name?.value) }}></div>
                            </div>

                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>Payments</div>
                              <ParsePaymentDates payment={truck?.payments} />
                            </div>
                          </Link>
                        )
                      })}
                    </div>
                    <Paginator fetchRecords={fetchNextTrucksRecords} currentPage={truckCurrentPage} pages={totalTruckPages}/>
                    <hr style={{margin: "30px auto"}} />
                  </>
                }

                {/* Payments */}
                {payments && payments.length > 0 && 
                  <>
                    <div className={classes.dataTitle}>Payments</div>
                    <div className={classes.dataList}>
                      {payments.map((payment, index) => {
                        return (
                          <div key={'payment_' + index} className={classes.dataCard}>
                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>Vendor Name</div>
                              <div dangerouslySetInnerHTML={{ __html: checkForEmptyValues(payment?._highlightResult?.vendor_name?.value) }}></div>
                            </div>

                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>Active Campaign</div>
                              <div dangerouslySetInnerHTML={{ __html: checkForEmptyValues(payment?._highlightResult?.campaign_name?.value) }}></div>
                            </div>

                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>Month</div>
                              <div>{moment().utc().format('MMMM YYYY')}</div>
                            </div>

                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>Pay this period</div>
                              <div dangerouslySetInnerHTML={{ __html: checkForEmptyValues('$' + payment?._highlightResult?.monthly_rate?.value) }}></div>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                    <Paginator fetchRecords={fetchNextPaymentsRecords} currentPage={paymentCurrentPage} pages={totalPaymentPages}/>
                    <hr style={{margin: "30px auto"}} />
                  </>
                }

                {/* Campaigns */}
                {campaigns && campaigns.length > 0 && 
                  <>
                    <div className={classes.dataTitle}>Campaigns</div>
                    <div className={classes.dataList}>
                      {campaigns.map((campaign, index) => {
                        return (
                          <Link to={`/dashboard/admin/advertise/campaign/edit/${campaign.campaign_id}`} onClick={() => togglePopup()} key={'campaign_' + index} className={classes.dataCard}>
                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>Campaign Name</div>
                              <div dangerouslySetInnerHTML={{ __html: checkForEmptyValues(campaign?._highlightResult?.campaign_name?.value) }}></div>
                            </div>

                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>Client Name</div>
                              <div dangerouslySetInnerHTML={{ __html: checkForEmptyValues(campaign?._highlightResult?.client_name?.value) }}></div>
                            </div>

                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>No. of trucks</div>
                              <div dangerouslySetInnerHTML={{ __html: checkForEmptyValues(campaign?.num_trucks) }}></div>
                            </div>

                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>Start Date</div>
                              <div>{moment(campaign?.start_date).utc().format('MM-DD-YYYY')}</div>
                            </div>

                            <div className={classes.dataGroup}>
                              <div className={classes.dataLabel}>End Date</div>
                              <div>{moment(campaign?.end_date).utc().format('MM-DD-YYYY')}</div>
                            </div>
                          </Link>
                        )
                      })}
                    </div>
                    <Paginator fetchRecords={fetchNextCampaignsRecords} currentPage={campaignCurrentPage} pages={totalCampaignPages}/>
                    <hr style={{margin: "30px auto"}} />
                  </>
                }
              </div>
            }
          </div>

          <span style={{ fontSize: 10, float: "right" }}>Powered by <img style={{ height: 16 }} src={algoliaLogo} /></span>
        </>  
      </ModalBody>
    </Modal>
  )
}

export default AlgoliaSearch;